export const SEMEN_TYPES = {
  CONVENTIONAL: 'Conv',
  SEXED_FEMALE: 'SF F',
  SEXED_MALE: 'SF M',
  INCOMPLETE: 'incomplete',
  RS_FEMALE: '.RS F',
  RS_MALE: '.RS M',
} as const;

export const STORAGE_LOCATIONS = {
  VATC: 'VATC',
  VATD: 'VATD',
  VATE: 'VATE',
  VATF: 'VATF',
  AGGIA_C: 'AGGIA - C',
  IASS_1: 'IASS - 1',
  IASS_2: 'IASS - 2',
  IASS_3: 'IASS - 3',
  IASS_6: 'IASS - 6',
  DROP_TANK: 'Drop Tank',
  TRAVEL_TANK: 'Travel Tank',
  SHIPPING: 'Shipping',
} as const;
